import clsx from 'clsx';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Author } from '../../interfaces/authors';
import NameList from '../NameList';

interface BylineWithHeadshotProps {
  authors: Author[];
  className?: string;
}

const BylineWithHeadshot = ({ authors, className }: BylineWithHeadshotProps) => {
  return (
    <QueryClientProvider client={new QueryClient()}>
      <div className="flex flex-wrap items-center gap-8 sm:gap-16">
        <div className="flex">
          {authors.map((author, index) => (
            <LazyLoadImage
              key={index}
              src={author.picture}
              alt={`${author.name} headshot`}
              width={40}
              height={40}
              style={{ zIndex: authors.length - index }}
              className="author-image -ml-12 rounded-full border border-solid border-white first:m-0"
            />
          ))}
        </div>
        <div
          className={clsx(
            'text-left font-suisse-screen text-byline-sm text-black sm:text-byline-lg',
            className
          )}
        >
          <NameList authors={authors} withTooltip />
        </div>
      </div>
    </QueryClientProvider>
  );
};

export default BylineWithHeadshot;
